import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "LoginPage" }
const _hoisted_2 = {
  key: 0,
  id: "loginPageButtons"
}
const _hoisted_3 = {
  key: 1,
  id: "signUp"
}
const _hoisted_4 = {
  type: "text",
  id: "pairingcode",
  required: "",
  ref: "pairingcode"
}
const _hoisted_5 = {
  type: "text",
  id: "username",
  required: "",
  ref: "username"
}
const _hoisted_6 = {
  type: "password",
  id: "password",
  required: "",
  ref: "password"
}
const _hoisted_7 = {
  type: "text",
  id: "firstname",
  required: "",
  ref: "firstname"
}
const _hoisted_8 = {
  type: "text",
  id: "lastname",
  required: "",
  ref: "lastname"
}
const _hoisted_9 = {
  type: "email",
  id: "email",
  required: "",
  ref: "email"
}
const _hoisted_10 = {
  type: "text",
  id: "address",
  ref: "address"
}
const _hoisted_11 = {
  key: 2,
  id: "logIn"
}
const _hoisted_12 = {
  type: "text",
  id: "username",
  required: "",
  ref: "username"
}
const _hoisted_13 = {
  type: "password",
  id: "password",
  required: "",
  ref: "password"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.shouldShowLogin && !_ctx.shouldShowSignup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.shouldShowSignup = true))
          }, "New Account"),
          _createElementVNode("button", {
            class: "sec",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shouldShowLogin = true))
          }, "Log in")
        ]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSignup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
          _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
          _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("form", {
            action: "/",
            id: "signUpForm",
            onSubmit: [
              _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
              _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitSignUp && _ctx.submitSignUp(...args)))
            ]
          }, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "pairingcode" }, [
              _createTextVNode("Pairing code "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_4, null, 512),
            _cache[8] || (_cache[8] = _createTextVNode()),
            _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "username" }, [
              _createTextVNode("Username "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_5, null, 512),
            _cache[12] || (_cache[12] = _createTextVNode()),
            _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "password" }, [
              _createTextVNode("Password "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_6, null, 512),
            _cache[16] || (_cache[16] = _createTextVNode()),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
            _cache[18] || (_cache[18] = _createElementVNode("label", { for: "firstname" }, [
              _createTextVNode("First name "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_7, null, 512),
            _cache[20] || (_cache[20] = _createTextVNode()),
            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
            _cache[22] || (_cache[22] = _createElementVNode("label", { for: "lastname" }, [
              _createTextVNode("Last name "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_8, null, 512),
            _cache[24] || (_cache[24] = _createTextVNode()),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "email" }, [
              _createTextVNode("E-mail "),
              _createElementVNode("span", { class: "required" }, "*")
            ], -1)),
            _cache[27] || (_cache[27] = _createTextVNode()),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_9, null, 512),
            _cache[29] || (_cache[29] = _createTextVNode()),
            _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
            _cache[31] || (_cache[31] = _createElementVNode("label", { for: "address" }, "Address", -1)),
            _cache[32] || (_cache[32] = _createTextVNode()),
            _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_10, null, 512),
            _cache[34] || (_cache[34] = _createTextVNode()),
            _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
            _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
            _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
            _cache[38] || (_cache[38] = _createElementVNode("button", { type: "submit" }, "Sign Up", -1))
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_ctx.shouldShowLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("form", {
            action: "/",
            id: "loginForm",
            onSubmit: [
              _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
              _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitLogin && _ctx.submitLogin(...args)))
            ]
          }, [
            _cache[42] || (_cache[42] = _createElementVNode("label", { for: "username" }, "Username", -1)),
            _cache[43] || (_cache[43] = _createTextVNode()),
            _cache[44] || (_cache[44] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_12, null, 512),
            _cache[45] || (_cache[45] = _createTextVNode()),
            _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
            _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
            _cache[48] || (_cache[48] = _createElementVNode("label", { for: "password" }, "Password", -1)),
            _cache[49] || (_cache[49] = _createTextVNode()),
            _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", _hoisted_13, null, 512),
            _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
            _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
            _cache[53] || (_cache[53] = _createElementVNode("button", { type: "submit" }, "Log in", -1))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}